import { query } from '@confluence/query-preloader-tools/entry-points/graphql.ts';
import { expValEquals } from '@confluence/feature-experiments';
import { fg } from '@confluence/feature-gating';
import { ssrContentStateManager } from '@confluence/ssr-utilities/entry-points/SSRContentStateManager.ts';
import { getSSRRenderInputs } from '@confluence/ssr-utilities/entry-points/ssrRenderInputs.ts';

import EditorContentStateQuery, {
	type EditorContentStateQuery$data,
	type EditorContentStateQuery$variables,
} from './__generated__/EditorContentStateQuery.graphql.ts';

type PreloadEditorContentStateParams = {
	contentId: any;
	useCache: boolean;
	shouldGetDraftVersion: boolean;
};

export function preloadEditorContentState({
	contentId,
	useCache,
	shouldGetDraftVersion,
}: PreloadEditorContentStateParams) {
	const contentStatePromise = query<
		EditorContentStateQuery$data,
		EditorContentStateQuery$variables
	>({
		query: EditorContentStateQuery,
		variables: {
			contentId,
			isDraft: shouldGetDraftVersion,
			shouldSkipContentStateLastUpdated: expValEquals('confluence_approvals_eap', 'isEnabled', true)
				? false
				: shouldGetDraftVersion,
			isApprovalsFgOn: expValEquals('confluence_approvals_eap', 'isEnabled', true),
			format: expValEquals('confluence_approvals_eap', 'isEnabled', true)
				? 'MILLIS'
				: 'USER_FRIENDLY',
		},
		fetchPolicy: useCache ? 'cache-first' : 'network-only',
	});

	if (!getSSRRenderInputs().uri || !fg('content_state_ssr_improvements')) {
		return contentStatePromise;
	}

	return contentStatePromise.then((result) => {
		if (result.data) {
			ssrContentStateManager.setContentStateData(result.data);
		}
		return result;
	});
}
